import {
    TypedUseSelectorHook,
    useDispatch,
    useSelector as useSelectorUntyped,
} from 'react-redux';
import type { RootState, AppDispatch } from '.';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorUntyped;
